/**
 * Created by JIA on 2020/3/21.
 *
 * A common service that many form edit/add may use
 * this service may not called by redux, so we split it out
 */
import ApiService from "../../../../ApiService";
import Constants from "../../../../../config/Constants";

const UnitService = {
    upload: (file, resourceId, successCallback, failureCallback) => {
        // all uploaded files are saved into this temp folder; once the unit is saved,
        // those files will be moved into unit folder;
        var unitTempFileFolderPath = Constants.FILE_STORAGE.TEMP_PATH + "units/" + resourceId + "/";

        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "Units");
        formData.append("field", "Data");
        formData.append("uploadPath", unitTempFileFolderPath);
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    },

    //
    // 停止使用这个服务，请使用generateDetails
    //
    generate: (chars, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unit/edit/generate", { chars }, successCallback, failureCallback);
    },

    generateWithSyllables: (chars, syllables, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unit/edit/generatewithsyllables", { chars, syllables }, successCallback, failureCallback);
    },

    generateAudioWithSyllables: (chars, syllables, voiceType, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unit/edit/generateaudiowithsyllables", { chars, syllables, voiceType }, successCallback, failureCallback);
    },

    //
    // wordArray: [ "朋友", "大家好", "你好" ]
    //
    generateDetails: (wordArray, successCallback, failureCallback) => {
        ApiService.post("/common/chinese/generate/details", { wordArray }, successCallback, failureCallback);
    },

    //
    // PinyinList: [ [ "peng", "you" ], [ "da", "jia", "hao" ], [ "ni", "hao" ] ]
    //
    generateAudios: (PinyinList, successCallback, failureCallback) => {
        ApiService.post("/common/chinese/generate/audios", { PinyinList }, successCallback, failureCallback);
    },

    generateUnit: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unit/edit/generateunit", vo, successCallback, failureCallback);
    },

    generateUnitData: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unit/edit/generateunitdata", vo, successCallback, failureCallback);
    },

    getAllRadicals: (successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/radical/list/getallradicals", {  }, successCallback, failureCallback);
    },

    generateUnitByTask: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unit/edit/generateunitbytask", vo, successCallback, failureCallback);
    },

    getTaskProgress: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unit/edit/gettaskprogress", { id }, successCallback, failureCallback);
    },

    getReadingCourses: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/readingbook/list/loadscreenview", { searchVO }, successCallback, failureCallback);
    },

    getSectionsByCourseId: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/oralbook/details/loadscreenview", searchVO, successCallback, failureCallback);
    },

    getUnitsBySectionId: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/oralbook/details/loadunits", searchVO, successCallback, failureCallback);
    },
};

export default UnitService;
